import React from 'react';
import { painPoints } from '../../data/content';
import { CTAButton } from '../CTAButton';
export function PainPoints() {
  return <section className="bg-sand py-14 sm:py-20" data-id="element-227" data-mp="1twgvaqob8894">
      <div className="mx-auto w-full max-w-4xl px-4" data-id="element-228" data-mp="27m281jbinr8p">
        <h2 className="text-center font-display text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-229" data-mp="27nvi78lc8tlg">
          Does this sound familiar?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15.5px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-230" data-mp="2hjp1datkblc7">
          If you answer <strong className="font-bold text-navy-900" data-id="element-231" data-mp="2ckvljbqszi8v">yes</strong> to any of these, Mechanics
          Decision Map™ was created for you.
        </p>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-232" data-mp="2mjume85bu9lb">
          {painPoints.map(item => <li key={item.text} className="flex h-full gap-3 rounded-2xl bg-white p-4 ring-1 ring-navy-900/10 sm:p-5" data-id="element-233" data-mp="w6vny7ffk4os">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-234" data-mp="s7d2najp5rlf">
                {item.emoji}
              </span>
              <p className="text-[14.5px] leading-relaxed text-navy-800/85 sm:text-[15px]" data-id="element-235" data-mp="1n5z22xl0jxa6">{item.text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-2xl rounded-2xl bg-navy-900 p-6 text-center sm:p-8" data-id="element-236" data-mp="1x4y8sam7xiuj">
          <p className="font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-237" data-mp="21xrdiyhosr6m">
            And it doesn’t have to feel this way.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-238" data-mp="2axe6cvwcooo2">
            Because the problem isn’t always a lack of knowledge. Sometimes the problem is simply not having
            a system that organizes that knowledge into a sequence of decisions.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-239" data-mp="lig5jbid57mg">
          <CTAButton label="I want a structured system" data-id="element-240" data-mp="ljrf5ryhp9lh" />
        </div>
      </div>
    </section>;
}